// Pantallas del sidebar que se pueden habilitar por usuario (Configuración > Usuarios > Pantallas).
export const PANTALLAS_SIDEBAR = [
  { seccion: 'Planificación', items: [
    { key: 'calendario', label: 'Calendario' },
    { key: 'aprobaciones', label: 'Aprobaciones' },
    { key: 'vencidos', label: 'Vencidos' },
  ]},
  { seccion: 'Geves', items: [
    { key: 'informes', label: 'Informes' },
    { key: 'reportes', label: 'Reportes' },
  ]},
  { seccion: 'Configuración', items: [
    { key: 'uso', label: 'Uso' },
    { key: 'plantillas_ppt', label: 'Plantillas PPT' },
    { key: 'configuracion', label: 'Configuración', hijos: [
      { key: 'configuracion.desarrolladores', label: 'Desarrolladores' },
      { key: 'configuracion.etiquetas', label: 'Etiquetas' },
      { key: 'configuracion.cuentas', label: 'Cuentas' },
      { key: 'configuracion.usuarios', label: 'Usuarios' },
    ]},
  ]},
];

export const TODAS_LAS_PANTALLAS = PANTALLAS_SIDEBAR.flatMap(s => s.items.map(i => i.key));
export const TABS_CONFIGURACION = ['desarrolladores', 'etiquetas', 'cuentas', 'usuarios'];
export const CLAVES_TABS_CONFIGURACION = TABS_CONFIGURACION.map(t => `configuracion.${t}`);

/**
 * ¿Puede el usuario ver esta pantalla del sidebar?
 * El rol NO interviene: los roles solo definen acciones sobre los posts.
 * - Superusuario: siempre ve todo (no se puede bloquear).
 * - Resto: solo las pantallas de pantallas_permitidas (Configuración > Usuarios > Pantallas).
 *   Sin lista configurada solo ve Calendario.
 */
export const tienePantalla = (user, key) => {
  if (!user) return false;
  if (user.is_superuser) return true;
  if (Array.isArray(user.pantallas_permitidas)) return user.pantallas_permitidas.includes(key);
  return key === 'calendario';
};

/**
 * ¿Puede el usuario ver esta pestaña de Configuración?
 * - Requiere poder ver la pantalla 'configuracion'.
 * - Superusuario: todas las pestañas.
 * - Resto: solo las marcadas ('configuracion.<tab>'). Una lista antigua con
 *   'configuracion' y sin ninguna pestaña marcada se interpreta como todas.
 */
export const tienePestanaConfiguracion = (user, tab) => {
  if (!tienePantalla(user, 'configuracion')) return false;
  if (user.is_superuser) return true;
  if (!Array.isArray(user.pantallas_permitidas)) return false;
  const lista = user.pantallas_permitidas;
  const hayTabs = CLAVES_TABS_CONFIGURACION.some(k => lista.includes(k));
  return hayTabs ? lista.includes(`configuracion.${tab}`) : true;
};
